import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/industries/market-research/components/MarketResearchDashboardsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/industries/market-research/components/MarketResearchFinancialImpactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/industries/market-research/components/MarketResearchHeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Header.tsx");
